import React from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import LocationIcon from "@mui/icons-material/LocationOnOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import datastore from '../../store/hoa-datastore';
import { getCommaSeparatedString } from "../../utility/comma-separated-string";
import PropertyTaskIgnoreOption from './property-task-ignore-option';

interface SubHeaderProps {
	view: string;
	warning?: boolean;
	loading?: boolean;
	selectedValues?: Record<string, any>;
	tagType?: string;
	selectedTabTitle?: string;
	onSaveClick?: () => void;
	onDeleteClick?: () => void;
	onCancelClick?: () => void;
	onUpdateClick?: () => void;
	editOptionEnabledFromView?: boolean;
	setIsBillableItemsModal?: (v: boolean) => void;
	state?: any;
	isMailSaveButtonDisabled?: () => boolean;
	isDisabled?: boolean;
	onCancelYesClick?: () => void;
	style?: React.CSSProperties;

}

export default function SubHeaderComponent({
	view,
	warning = false,
	loading = false,
	selectedValues = {},
	tagType = '',
	selectedTabTitle = '',
	onSaveClick = () => {},
	onDeleteClick = () => {},
	onCancelClick = () => {},
	onUpdateClick = () => {},
	editOptionEnabledFromView = false,
	setIsBillableItemsModal = () => {},
	state = {},
	isMailSaveButtonDisabled = () => false,
	isDisabled = false,
	onCancelYesClick = () => {},

}: SubHeaderProps) {

	const saveBtnClicked = () => {
		if((tagType == 'HOA' || tagType == 'Property' || tagType == 'Municipality') && view === 'update') {
			setIsBillableItemsModal(true);
		}
		else {
			onSaveClick();
		}
	}

	return (
		<div className="sub-header-container">
			<div className="sub-header-container-filter">
				<div style={{ display: "flex", flexDirection: "column" }}>
					{(view === "add" || view === "selectHoa") ? (
						<>
						{(tagType === 'Property' && view === 'selectHoa') ? <span className="titleText">Add HOA Information</span> : <span className="titleText">Add New {tagType}</span> }
						</>
					) : view === "update" && tagType === 'HOA' ? (
						<span className="titleText">Edit {tagType}</span>
					) : view === "update" && tagType != 'Hoa' ? (
						<span className="titleText">Update {selectedTabTitle}</span>
					) : (view === "assign" || tagType === 'Mail')  ? (
						selectedValues.property?.objectId ?
						<>
							<span className="titleText">Assigned Document</span>
							<span className="helperText">
								{`Sent To ${selectedValues.sendTo?.address}.`}
							</span>
						</>
						:<>
							<span className="titleText">Assign Document</span>
							<span className="helperText">
								{`Please assign the document for ${selectedValues.sendTo?.address}.`}
							</span>
						</>
					) : (
						<div style={{ display: "flex" }}>
							<span className="titleText">{getCommaSeparatedString(tagType, selectedValues.name) }</span>
							{warning ? (
								<div className="title-status text-3E3E3E-13px">Incomplete</div>
							) : (
								""
							)}
						</div>
					)}
					{(view === "add" || view === "selectHoa") ? (
						<span className="helperText">
							{(tagType === 'Property' && view === 'selectHoa') ? `Please fill up the necessary information to add HOA into Property.` : `Please fill up the necessary information to add ${tagType}.`}
						</span>
					) : view === "update" && tagType === "HOA" ? (
						<span className="helperText">
							{selectedValues.name}
						</span>
					) : view === "update" && tagType != "HOA" ? (
						<span className="helperText">
							Please fill up the necessary information to update {tagType.toLowerCase()} details.
						</span>
					)
					 : (view === "assign" || tagType === 'Mail') ? (
						<span className="helperText">
							{
								selectedTabTitle &&
								<>Please assign the document for {selectedTabTitle}</>
							}
						</span>
					) : (
						<div style={{ display: "flex", flexDirection: "row" }}>
							<LocationIcon />
							<span
								className="helperText"
								style={{ marginLeft: "5px", fontSize: "14px" }}
							>
								{selectedValues.officeAddress || selectedValues.address || selectedValues.fullAddress}
							</span>
						</div>
					)}
				</div>
				<div>
					{(view !== "view" || tagType === 'Mail') && datastore.isUserPermitted(tagType, 'add') && (
						<div style={{ display: "flex", flexDirection: "row" }}>
							<PropertyTaskIgnoreOption />
							<Button
							    disabled={loading}
								id='hoa-cancel-click'
								variant="outlined"
								color="primary"
								style={{ height: "40px", padding: "5px 25px", marginRight: "5px" }}
								onClick={(isDisabled  && view !== 'add') ||isMailSaveButtonDisabled() ? onCancelYesClick: onCancelClick}
							>
								Cancel
							</Button>
							<Button
								disabled={view === 'update' ? isDisabled : false || view === 'selectHoa' || (tagType === 'Mail' && isMailSaveButtonDisabled())}
								id='hoa-save-click'
								variant="contained"
								color="primary"
								style={{ height: "40px", padding: "5px 25px" }}
								onClick={saveBtnClicked}
							>
								{loading ? (tagType === "Mail" ? "Verifying..." : "Saving...") : (tagType === "Mail" ? "Verify" : "Save")}
							</Button>
						</div>
					)}
					{view === "view" && editOptionEnabledFromView && (
						<div style={{ display: "flex", flexDirection: "row" }}>
							<PropertyTaskIgnoreOption />
							{
								datastore.isUserPermitted(tagType, 'update') &&
								<Button
									variant="contained"
									color="primary"
									startIcon={<EditIcon />}
									style={{ height: "40px", padding: "5px 25px", marginRight: "5px" }}
									onClick={onUpdateClick}
								>
									Edit
								</Button>
							}
							{
								datastore.isUserPermitted(tagType, 'view', 'delete') &&
								<IconButton
									onClick={onDeleteClick}
									style={{
										height: "40px",
										border: "1px solid #E8E8E8",
										borderRadius: "4px",
									}}
								>
									<DeleteOutlineIcon
										style={{
											width: "20px",
											height: "20px",
										}}
									/>
								</IconButton>
							}
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
